import { Donuz } from "donuz-js/Donuz";
import carousel from 'vue-owl-carousel';
import Loading from "@/components/Loading.vue";

// @ is an alias to /src
export default {
    name: "prize",
    components: {
        carousel,
        Loading
    },
    data() {
        return {
            obj: {},
            quantity: 1,
            prize: {},
            loading: true,
            client: {}
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        let response = await Donuz.prizes.getInfoReward(this.$route.params.id, null, null);
        if (response.status == 200) {
            this.prize = response.premios[0];
        }
        if (sessionStorage.getItem(btoa("cliente")) != null) {
            this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
        }
        this.loading = false
    },
    methods: {

        submit: async function (e) {

            if (Object.keys(this.client).length == 0) {
                location.href = "/login";
                return;
            }

            if (this.prize.titulo == 'ANIVERSÁRIO') {
                if (new Date(this.client.dt_nascimento).getMonth() != new Date().getMonth()) {
                    this.$swal.fire({
                        title: 'Atenção!',
                        text: "Este prêmio só poderá ser resgatado no mês do seu aniversário!",
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok',
                    })
                    return
                }
            }

            this.$swal.fire({
                title: 'Atenção!',
                text: "Tem certeza que deseja resgatar esse prêmio?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.value) {

                    let result;

                    if (this.prize.titulo == 'ANIVERSÁRIO') {
                        if (!parseFloat(this.client.saldo) > 0) {
                            this.$swal.fire({
                                title: 'Opss ...',
                                text: "Você não possuiu nenhum ponto para ser convertido em desconto.",
                                confirmButtonColor: '#3085d6',
                                confirmButtonText: 'Ok',
                            })
                            return
                        }
                        result = await Donuz.redeemption.redeemRewards(
                            sessionStorage.getItem(btoa("tokenCliente")), { quantidade: parseFloat(this.client.saldo) * 33.3333 , id_premio: this.$route.params.id }
                        );
                    } else {
                        result = await Donuz.redeemption.redeemRewards(
                            sessionStorage.getItem(btoa("tokenCliente")), { quantidade: this.quantity, id_premio: this.$route.params.id }
                        );
                    }

                    if (result.status == 200) {
                        M.toast({ html: result.mensagem, classes: "green" });
                        let voucher = result.voucher
                        result = await Donuz.balance.getCustomerBalance(sessionStorage.getItem(btoa("tokenCliente")))
                        if (result.status == 200) {
                            this.client.saldo = result.saldo
                            sessionStorage.setItem(btoa("cliente"), btoa(JSON.stringify(this.client)))
                        }
                        location.href = this.baseUrl + 'voucher/' + voucher
                    } else {
                        M.toast({ html: result.mensagem, classes: "red" });
                    }

                }
            })


        }
    }
};